
export default function IndustryExpertise() {
  const industries = [
    { name: 'Technology', icon: 'ri-computer-line' },
    { name: 'Healthcare', icon: 'ri-heart-pulse-line' },
    { name: 'Finance', icon: 'ri-bank-line' },
    { name: 'Manufacturing', icon: 'ri-factory-line' },
    { name: 'Retail', icon: 'ri-shopping-bag-line' },
    { name: 'Engineering', icon: 'ri-tools-line' },
    { name: 'Legal', icon: 'ri-scales-3-line' },
    { name: 'Hospitality', icon: 'ri-hotel-line' }
  ];

  return (
    <section id="industries" className="py-20 lg:py-28 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Industries We Serve
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-8">
              Our deep industry knowledge and extensive network enable us to deliver specialized recruitment solutions across diverse sectors. We understand the unique challenges and requirements of each industry we serve.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Discuss Your Industry Needs
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          {/* Right - Industry Pills */}
          <div className="grid grid-cols-2 gap-4">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="group bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 rounded-lg group-hover:bg-teal-500/30 transition-colors">
                    <i className={`${industry.icon} text-2xl text-teal-400`}></i>
                  </div>
                  <span className="text-white font-semibold text-lg">
                    {industry.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
